import { CronDayType, CronIntervalType } from "./types";

export const CRON_DAY_OPTIONS = [
  {
    value: CronDayType.SUN,
    label: "Sun",
  },
  {
    value: CronDayType.MON,
    label: "Mon",
  },
  {
    value: CronDayType.TUE,
    label: "Tue",
  },
  {
    value: CronDayType.WED,
    label: "Wed",
  },
  {
    value: CronDayType.THU,
    label: "Thu",
  },
  {
    value: CronDayType.FRI,
    label: "Fri",
  },
  {
    value: CronDayType.SAT,
    label: "Sat",
  },
];

export const CRON_MONTH_OPTIONS = [
  {
    value: 1,
    label: "Jan",
  },
  {
    value: 2,
    label: "Feb",
  },
  {
    value: 3,
    label: "Mar",
  },
  {
    value: 4,
    label: "Apr",
  },
  {
    value: 5,
    label: "May",
  },
  {
    value: 6,
    label: "Jun",
  },
  {
    value: 7,
    label: "Jul",
  },
  {
    value: 8,
    label: "Aug",
  },
  {
    value: 9,
    label: "Sep",
  },
  {
    value: 10,
    label: "Oct",
  },
  {
    value: 11,
    label: "Nov",
  },
  {
    value: 12,
    label: "Dec",
  },
];

export const CRON_INTERVALS = [
  {
    dataKey: CronIntervalType.WEEKLY,
    label: "Weekly",
  },
  {
    dataKey: CronIntervalType.MONTHLY,
    label: "Monthly",
  },
];

export const getHourOptions = () =>
  Array.from({ length: 24 }, (_, i) => {
    const hour = i % 12 === 0 ? 12 : i % 12;
    const period = i < 12 ? "AM" : "PM";
    return {
      value: i.toString(),
      label: `${hour} ${period}`,
    };
  });

export const getMinutesOptions = () =>
  Array(60)
    .fill(0)
    .map((_, i) => ({
      value: i.toString(),
      label: i.toString(),
    }));

export const getDayOfMonthOptions = () =>
  Array(31)
    .fill(0)
    .map((_, i) => ({
      value: (i + 1).toString(),
      label: (i + 1).toString(),
    }));
